<template>
  <div id="classification">
    <div class="top">
      <div class="title">售后信息\ {{ contractId }}</div>
    </div>
    <div class="mian-card">
      <div class="left">
        <!-- <div class="card-top">
              <div class="card-title">BOM信息概览\03.01.02.04.0001</div>
              <div class="card-tool">任务详情</div>
            </div> -->
        <card-m
          :title="'售后列表' + contractId"
          cardWidth="96%"
          cardHeight="80vh"
          minHeight="48vh"
          maxHeight="90vh"
        >
          <template slot="card-box">
            <cardTable
              :total="AfterSalesTotal"
              @sizeChange="handleAfterSalesPageSizeChanges"
              @currentChange="handlecurrentAfterSalesChanges"
              :tableColumn="AfterSalesListColumn"
              :tableData="AfterSalesList"
              @rowClick="goToDetail"
            ></cardTable>
          </template>
        </card-m>
      </div>
      <!-- <div class="right"> -->
      <el-dialog
        :visible="AfterSalesDetailVisible"
        :before-close="closeAfterSalesDetail"
        width="85%"
      >
        <card-m
          title="详情"
          cardWidth="96%"
          cardHeight="60vh"
          minHeight="48vh"
          maxHeight="90vh"
        >
          <template slot="card-box">
            <cardTable
              :total="AfterSalesDetailTotal"
              @sizeChange="handleAfterSalesDetailPageSizeChanges"
              @currentChange="handlecurrentAfterSalesDetailChanges"
              :tableColumn="AfterSalesDetailListColumn"
              :tableData="AfterSalesDetailList"
            ></cardTable>
          </template>
        </card-m>
      </el-dialog>
      <!-- </div> -->
    </div>
    <el-dialog
      :visible="AfterSalesDetailDialogVisible"
      :before-close="closeAfterSalesDetailDialog"
      title="详情"
      width="50%"
    >
      <div class="info-box">
        <div class="info-box-item">
          名称: <span>{{ currentAfterSalesDetailData.field0051 }}</span>
        </div>
        <div class="info-box-item">
          数量: <span>{{ currentAfterSalesDetailData.field0054 }}</span>
        </div>
        <div class="info-box-item">
          单位: <span>{{ currentAfterSalesDetailData.field0053 }}</span>
        </div>
        <div class="info-box-item">
          属性: <span>{{ currentAfterSalesDetailData.field0055 }}</span>
        </div>
        <div class="info-box-item">
          返厂: <span>{{ currentAfterSalesDetailData.field0063 }}</span>
        </div>
        <div class="info-box-item">
          质量原因: <span>{{ currentAfterSalesDetailData.field0066 }}</span>
        </div>
        <div class="info-box-item">
          出库数量: <span>{{ currentAfterSalesDetailData.field0070 }}</span>
        </div>
        <div class="info-box-item">
          短代码: <span>{{ currentAfterSalesDetailData.field0050 }}</span>
        </div>
        <div class="info-box-item">
          交付日期: <span>{{ currentAfterSalesDetailData.field0056 }}</span>
        </div>
        <div class="info-box-item" style="width: 500px">
          领料原因: <span>{{ currentAfterSalesDetailData.field0064 }}</span>
        </div>
        <div class="info-box-item" style="width: 500px">
          物流信息: <span>{{ currentAfterSalesDetailData.field0093 }}</span>
        </div>
      </div></el-dialog
    >
    <el-dialog title="详情" :visible.sync="xianchangVisible">
      <el-descriptions :column="2">
        <el-descriptions-item label="合同号">{{
          xianchangDialogData[0].合同号
        }}</el-descriptions-item>
        <el-descriptions-item label="用户">{{
          xianchangDialogData[0].用户
        }}</el-descriptions-item>
        <el-descriptions-item label="地址">{{
          xianchangDialogData[0].地址
        }}</el-descriptions-item>
        <el-descriptions-item label="计划到达日期">{{
          xianchangDialogData[0].计划到达日期
        }}</el-descriptions-item>
        <el-descriptions-item label="计划完成日期">{{
          xianchangDialogData[0].计划完成日期
        }}</el-descriptions-item>
        <el-descriptions-item label="实际完成日期">{{
          xianchangDialogData[0].实际完成日期
        }}</el-descriptions-item>
        <el-descriptions-item label="服务进度">{{
          xianchangDialogData[0].服务进度
        }}</el-descriptions-item>
        <el-descriptions-item label="余留问题">{{
          xianchangDialogData[0].余留问题
        }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions
        :key="index"
        v-for="(item, index) in xianchangDialogData[1]"
        :column="1"
      >
        <el-descriptions-item label="产品型号">{{
          item.产品型号
        }}</el-descriptions-item>
        <el-descriptions-item label="服务详情">{{
          item.服务详情
        }}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script>
import { apiMain, apiMainMultiple } from '@/api/mainapi.js';
export default {
  name: 'classification',
  data() {
    return {
      xianchangDialogData: [
        {
          合同号: '',
          用户: '',
          地址: '',
          计划到达日期: '',
          计划完成日期: '',
          实际完成日期: '',
          服务进度: ''
        },
        []
      ],

      xianchangVisible: false, //现场详情
      AfterSalesDetailDialogVisible: false, //详情列表点击弹框
      AfterSalesDetailVisible: false, //主表详情点击弹框
      currentAfterSalesDetailData: {}, //当前点击的详情弹框数据
      contractId: '', //内存中存储的合同号
      currentKey: '', //当前售后详情key
      currentAfterSalesPage: 1, //当前页
      AfterSalesTotal: 0, //总数据数
      AfterSalesPageSize: 5, //
      currentAfterSalesDetailPage: 1, //详情当前页
      AfterSalesDetailTotal: 0, //详情总数据数
      AfterSalesDetailPageSize: 5, //
      AfterSalesListColumn: [
        {
          prop: '合同号',
          label: '合同号'
        },
        {
          prop: '用户',
          label: '用户'
        },

        {
          prop: '地址',
          label: '地址'
        },
        {
          prop: '类型',
          label: '类型'
        },
        {
          prop: '负责人',
          label: '负责人'
        },
        {
          prop: '进度',
          label: '进度'
        }
        //  {
        //   width:80,
        //   actions:[
        //     {
        //        fnName: 'goToDetail',
        //        label: '详情',
        //     },
        //   ]
        // }
      ],
      AfterSalesDetailListColumn: [],
      AfterSalesDetailListColumn1: [
        {
          prop: '名称',
          label: '名称'
        },

        {
          prop: '数量',
          label: '数量'
        },
        {
          prop: '单位',
          label: '单位'
        },
        {
          prop: '属性',
          label: '属性'
        },
        {
          prop: '发货信息',
          label: '发货信息'
        },
        // {
        //   prop: 'field0064',
        //   label: '领料原因'
        // },
        {
          prop: '待发数',
          label: '待发数'
        },
        {
          prop: '可用库存',
          label: '可用库存'
        },
        {
          prop: '使用库存',
          label: '使用库存'
        },
        {
          prop: '使用库存',
          label: '使用库存'
        },
        {
          prop: '出库数量',
          label: '出库数量'
        },
        {
          prop: '是否出库',
          label: '是否出库'
        },
        {
          prop: '是否返厂',
          label: '是否返厂'
        },
        {
          prop: '短代码',
          label: '短代码'
        },
        {
          prop: '紧急程度',
          label: '紧急程度'
        },
        {
          prop: '领料原因',
          label: '领料原因'
        },
        {
          prop: '描述',
          label: '描述'
        }
      ],
      AfterSalesDetailListColumn2: [
        {
          prop: '合同号',
          label: '合同号'
        },
        {
          prop: '用户',
          label: '用户'
        },

        {
          prop: '地址',
          label: '地址'
        },
        {
          prop: '计划到达日期',
          label: '计划到达日期'
        },
        {
          prop: '计划完成日期',
          label: '计划完成日期'
        },
        {
          prop: '实际完成日期',
          label: '实际完成日期'
        },
        {
          prop: '服务进度',
          label: '服务进度'
        },
        {
          prop: '服务记录',
          label: '服务记录'
        },
        {
          prop: '备注',
          label: '备注'
        }
      ],
      AfterSalesList: [],
      AfterSalesDetailList: [],
      deatilData: {} //售后信息详情弹窗数据
    };
  },
  computed: {
    FBOMNumber() {
      if (window.location.href.indexOf('id') > 0) {
        let url = window.location.href;
        let FBOMNumber = decodeURIComponent(url).split('?id=')[1];
        return FBOMNumber;
      } else if (window.sessionStorage.getItem('currentFBOMNumber')) {
        return window.sessionStorage.getItem('currentFBOMNumber');
      }
    }
  },
  mounted() {
    let FBOMNumber;
    if (window.location.href.indexOf('id') > 0) {
      let url = window.location.href;
      FBOMNumber = decodeURIComponent(url).split('?id=')[1];
      window.sessionStorage.setItem('currentFBOMNumber', FBOMNumber);
      window.sessionStorage.setItem('currentContractId', FBOMNumber);
    } else if (window.sessionStorage.getItem('currentFBOMNumber')) {
      FBOMNumber = window.sessionStorage.getItem('currentFBOMNumber');
    }
    let contractId = window.sessionStorage.getItem('currentContractId');
    this.contractId = contractId;
    this.getAfterSales(contractId);
  },
  methods: {
    //根据合同号查询售后信息
    async getAfterSales(contractId) {
      const params = {
        Type: 'AfterSales',
        contractNo: contractId,
        Page: this.currentAfterSalesPage,
        PageSize: this.AfterSalesPageSize
      };
      const res = await apiMainMultiple(params);
      this.AfterSalesTotal = res.data.data.total;
      this.AfterSalesList = res.data.data.list;
    },
    goToDetail(data) {
      if (data.类型 == '现场') {
        this.xianchangVisible = true;
        this.AfterSalesDetailListColumn = this.AfterSalesDetailListColumn2;
      } else {
        this.AfterSalesDetailVisible = true;
        this.AfterSalesDetailListColumn = this.AfterSalesDetailListColumn1;
      }

      this.deatilData = data;
      this.getAfterSalesDetail(data);
    },
    // 详情信息排序
    sortByValue(arr) {
      arr.sort(function (a, b) {
        return parseInt(a.field0048) - parseInt(b.field0048);
      });
    },
    //通过售后信息key 查询售后详情信息
    async getAfterSalesDetail(data) {
      const params = {
        Type: 'AfterSalesSon',
        key: data.id,
        projectStatus: data.类型,
        Page: this.currentAfterSalesDetailPage,
        PageSize: this.AfterSalesDetailPageSize
      };
      const res = await apiMainMultiple(params);
      this.AfterSalesDetailTotal = res.data.data.total;

      this.AfterSalesDetailList = res.data.data.list;
      if (data.类型 == '现场') {
        this.xianchangDialogData[0] = res.data.data.list[0];
        this.xianchangDialogData[1] = [];
        res.data.data.list.forEach((item, index) => {
          if (index > 0) {
            this.xianchangDialogData[1].push(item);
          }
        });
        console.log('现场弹框数据', this.AfterSalesDetailList);
      }
      // console.log(this.AfterSalesDetailList)
    },
    handleAfterSalesPageSizeChanges(val) {
      console.log(`每页 ${val} 条`);
      this.AfterSalesPageSize = val;
      this.getAfterSales(this.contractId);
    },
    handlecurrentAfterSalesChanges(val) {
      console.log(`当前页: ${val}`);
      this.currentAfterSalesPage = val;
      this.getAfterSales(this.contractId);
    },
    handleAfterSalesDetailPageSizeChanges(val) {
      console.log(`每页 ${val} 条`);
      this.AfterSalesDetailPageSize = val;
      this.getAfterSalesDetail(this.deatilData);
    },
    handlecurrentAfterSalesDetailChanges(val) {
      console.log(`当前页: ${val}`);
      this.currentAfterSalesDetailPage = val;
      this.getAfterSalesDetail(this.deatilData);
    },
    // 关闭详情列表点击弹框
    closeAfterSalesDetailDialog() {
      this.AfterSalesDetailDialogVisible = false;
    },
    // 关闭主表详情点击弹框
    closeAfterSalesDetail() {
      this.AfterSalesDetailVisible = false;
    },
    // 打开详情列表弹框
    showDetailInfo(data) {
      this.AfterSalesDetailDialogVisible = true;
      this.currentAfterSalesDetailData = data;
    }
  }
};
</script>

<style scoped lang="scss">
#classification {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;

  .left {
    width: 80%;
    height: 100%;
    display: flex;
    justify-content: center;
    padding-left: 40px;
  }
  .right {
    width: 46%;
    height: 100%;
  }
}
.top {
  // height: 7%;
  height: 70px;
  width: 100%;
  // background-color: rgb(145, 113, 71);
  .title {
    position: relative;
    // left: 5%;
    left: 80px;
    // width: 20%;
    width: 450px;
    height: 97%;
    font-size: 1.5rem;
    color: rgba(37, 100, 207, 0.8);
    border-bottom: 0.07rem solid rgba(105, 105, 105, 0.5);
    display: flex;
    align-items: center;
  }
}
.right {
  .top {
    // height: 7%;
    height: 70px;
    width: 100%;
    // background-color: rgb(145, 113, 71);
    .title {
      position: relative;
      // left: 5%;
      left: 80px;
      // width: 20%;
      width: 280px;
      height: 97%;
      font-size: 1.5rem;
      color: rgba(37, 100, 207, 0.8);
      border-bottom: 0.07rem solid rgba(105, 105, 105, 0.5);
      display: flex;
      align-items: center;
    }
  }
}
.card-box {
  height: 90%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 24px;
  .left_1 {
    position: relative;
    width: 95%;
    height: 85vh;
    background: rgb(255, 255, 255);
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    margin-bottom: 36px;
  }
  .right_1 {
    position: relative;
    width: 100%;
    height: 38vh;
    background: rgb(255, 255, 255);
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    margin-bottom: 33px;
  }
  .right_2 {
    position: relative;
    width: 100%;
    height: 38vh;
    background: rgb(255, 255, 255);
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    margin-bottom: 33px;
  }
}
.card-top {
  display: flex;
  align-items: center;
}
.card-title {
  position: relative;
  color: rgb(128, 128, 128);
  font-family: Microsoft YaHei;
  font-size: 20px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: -1px;
  text-align: left;
  margin: 20px;
  width: 60%;
}
.card-tool {
  position: relative;
  color: rgba(37, 100, 207, 0.8);
  font-family: Microsoft YaHei;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -1px;
  text-align: left;
  text-decoration-line: underline;
  cursor: pointer;
}
.card_info {
  position: relative;
  height: 65%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: row;
  -webkit-box-align: start;
  -ms-flex-align: start;
  -ms-flex-pack: distribute;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-content: space-around;
  padding-left: 20px;
}
.card_info_lable {
  width: 45%;
  color: #616161;
  font-family: 'Microsoft YaHei';
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
  span {
    color: #888888;
  }
}
.mian-card {
  display: flex;
  height: 100%;
  width: 100%;
  top: 20px;
  position: relative;
}
.progress {
  display: flex;
  justify-content: space-around;
  width: 90%;
  align-items: center;
}
.card-table {
  padding: 0 20px 0 20px;
}
.table-bottom {
  position: absolute;
  bottom: 20px;
  left: 20%;
}
.info-box {
  width: 100%;
  height: 300px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: flex-start;
  .info-box-item {
    width: 200px;
    font-size: 17px;
    font-weight: 600;
    display: flex;
    justify-content: flex-start;
    height: 50px;
    span {
      font-weight: 400;
    }
  }
}
</style>
